let backgroundRefresh = false
let leavingPage = false

document.addEventListener("turbo:before-render", (event) => {
  leavingPage = false
  backgroundRefresh = event.detail.renderMethod === "morph"
})

function recordPageView(url) {
  if (!url) return
  if (leavingPage || backgroundRefresh || document.documentElement.hasAttribute("data-turbo-preview")) return
  if (window.navigator.globalPrivacyControl) return
  const form = document.querySelector("[data-analytics-page-view]")
  if (!form) return
  if (form.elements.page_path.value !== new URL(url).pathname) return

  form.elements.event_id.value ||= window.crypto.randomUUID()
  form.elements.referrer_host.value = ""
  try {
    const referrer = new URL(document.referrer)
    if (referrer.origin !== window.location.origin) form.elements.referrer_host.value = referrer.hostname
  } catch { /* Empty referrers are direct visits. */ }
  form.requestSubmit()
}

document.addEventListener("turbo:load", (event) => recordPageView(event.detail?.url))

document.addEventListener("turbo:before-cache", () => {
  leavingPage = true
  const form = document.querySelector("[data-analytics-page-view]")
  if (form) form.elements.event_id.value = ""
})

window.addEventListener("pageshow", (event) => {
  if (!event.persisted) return
  leavingPage = false
  backgroundRefresh = false
  const form = document.querySelector("[data-analytics-page-view]")
  if (form) form.elements.event_id.value = ""
  recordPageView(window.location.href)
})
